// Every season, each hosted on its own domain/subdomain. Update
// `currentSeasonId` per branch/deployment (the current season's site is
// this deployment itself, so it's shown highlighted rather than as a link).
export const seasons = [
  { id: "2023-24", label: "2023-24 sezonu", url: "https://2023-24.ensuperlig.com/" },
  { id: "2024-25", label: "2024-25 sezonu", url: "https://2024-25.ensuperlig.com/" },
  { id: "2025-26", label: "2025-26 sezonu", url: "https://ensuperlig.com/" },
];

export const currentSeasonId = "2025-26";
